import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取租赁品牌数据（小票审核列表查询的品牌数据）
 */
export const fetchServiceBrandList = async () => {
    const res = await GET(APIs.API_BASIC_GETSERVICEBRANDLIST);

    return res.data.data ?? {};
};

/**
 * 小票审核列表
 */
export const fetchExamineReceiptList = async (params) => {
    const res = await GET(APIs.API_RECEIPT_EXAMINERECEIPTLIST, { params });

    return res.data.data ?? {};
};

/**
 * 通过或者拒绝审核列表的小票
 */
export const fetchEditExamineReceipt = async (data) => {
    const res = await POST(APIs.API_RECEIPT_EDITEXAMINERECEIPT, { data });

    return res.data ?? {};
};